export default __webpack_public_path__ + "static/media/purplelab.28f35a88.svg";